import { createSelector } from 'reselect';

import { appState } from './utils';

export const getLookupData = createSelector(appState, ({ lookupData }) => lookupData);
